import { ListItem, Box, AHText, AHTeamIconRelay } from "arkh";
import React from "react";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import {
  OrgStoreWorkspaceBreadcrumbsWithoutExternalId,
} from "../../OrgStores/OrgStoreWorkspaceBreadcrumbs";
import { OrgTeamListItem_team$key } from "./__generated__/OrgTeamListItem_team.graphql";

export function OrgTeamListItem(props: {
  isLast: boolean;
  isSelected: boolean;
  onPress: () => void;
  onToggleSelect: () => void;
  team: OrgTeamListItem_team$key;
}) {
  const team = useFragment(
    graphql`
      fragment OrgTeamListItem_team on Team {
        name
        ...AHTeamIcon
        color

        topics {
          id
          name
        }
        store {
          name
          ...OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store
        }
      }
    `,
    props.team
  );
  return (
    <ListItem
      isLast={props.isLast}
      onPress={props.onToggleSelect}
      left={<ListItem.MultiSelectIndicator selected={props.isSelected} />}
      right={
        <Box style={{ alignItems: "flex-end" }}>
          <ListItem.SubTitle>{team.store.name}</ListItem.SubTitle>
          <AHText type="detail">
            <OrgStoreWorkspaceBreadcrumbsWithoutExternalId store={team.store} />
          </AHText>
        </Box>
      }
      border="border-primary"
      displayMode="TABLE"
    >
      <Box>
        <Box
          style={{
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <AHTeamIconRelay team={team} customColor={team.color ?? undefined} />
          <Box spaceRight="xsmall" />

          <ListItem.Title>{team.name}</ListItem.Title>
        </Box>
        <Box
          style={{
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "center",
          }}
          spaceTop="xsmall"
          gap="small"
        >
          {team.topics?.map((t) => (
            <Box
              cornerRadius="medium"
              key={t.id}
              borderColor="border-primary"
              style={{
                borderWidth: 1,
              }}
              spaceHorizontal="small"
              spaceVertical="xxsmall"
            >
              <AHText type="detail">{t.name}</AHText>
            </Box>
          ))}
        </Box>
      </Box>
    </ListItem>
  );
}
